export default __webpack_public_path__ + "static/GeneralGrotesqueMono-Book-a7af8df38df900ba2af5cb2a98423afc.woff";